import React from 'react';
import type { FillAppFieldComment } from 'global/fillapp';

// Provided by FillAppReview; consumed only by FillAppField. Null (the default)
// means no comment UI — FillAppSubtab/RepeatingGroup stay comment-agnostic.
export type TutorFillAppCommentsCtx = {
    commentsByQid: Record<string, FillAppFieldComment[]>;
    currentTutorId: number | null;
    addComment: (qid: string, body: string) => Promise<void>;
    updateComment: (commentId: number, body: string) => Promise<void>;
    deleteComment: (commentId: number) => Promise<void>;
};

export const FillAppCommentsContext = React.createContext<TutorFillAppCommentsCtx | null>(null);
